'use client'

import { useContext, useEffect } from 'react'
import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { Route } from 'next'
import ModalContext from '@/app/_providers/ModalProvider/ModalContext'
import { ErrorType } from '@/types/errors.types'

/**
 * Reads the `?error=` URL param on mount, triggers the appropriate error modal,
 * and removes the param from the URL. Replaces `useUrlParams` from the legacy ticketing app.
 */
const useAuthErrorUrlParam = (): void => {
  const searchParams = useSearchParams()
  const pathname = usePathname()
  const router = useRouter()
  const { setErrorModal } = useContext(ModalContext)

  useEffect(() => {
    const error = searchParams.get('error')
    if (!error) return

    if (error === 'login') {
      setErrorModal({ type: ErrorType.Login })
    }

    const params = new URLSearchParams(searchParams.toString())
    params.delete('error')
    router.replace((params.size > 0 ? `${pathname}?${params.toString()}` : pathname) as Route)
  }, [searchParams, pathname, router, setErrorModal])
}

export default useAuthErrorUrlParam
